import React from 'react';
import { GeneratedMealPlan, MealType } from '../../utils/MealPlanner/types';

type WeeklyDashboardProps = {
  plan: GeneratedMealPlan | null;
};

const mealOrder: MealType[] = ['breakfast', 'lunch', 'dinner'];

function WeeklyDashboard({ plan }: WeeklyDashboardProps) {
  if (!plan) {
    return (
      <section className="meal-planner-panel meal-planner-empty">
        <h2>Weekly dashboard</h2>
        <p>Set your cap, add fridge items, and generate a plan.</p>
      </section>
    );
  }

  const days = Array.from(new Set(plan.meals.map((meal) => meal.day)));

  return (
    <section className="meal-planner-panel meal-planner-dashboard" aria-labelledby="weekly-dashboard-title">
      <div className="meal-planner-panel-header">
        <div>
          <h2 id="weekly-dashboard-title">Weekly dashboard</h2>
          <p>{plan.meals.length} meals planned</p>
        </div>
        <strong className={plan.budgetStatus === 'over' ? 'is-over' : ''}>
          EUR {plan.totalCost.toFixed(2)} / EUR {plan.budgetCap.toFixed(2)}
        </strong>
      </div>

      {plan.warnings.length > 0 && (
        <div className="meal-planner-warning" role="status">
          {plan.warnings[0]}
        </div>
      )}

      <div className="meal-planner-calendar">
        {days.map((day) => (
          <article key={day}>
            <h3>{day}</h3>
            {mealOrder.map((mealType) => {
              const meal = plan.meals.find((candidate) => candidate.day === day && candidate.mealType === mealType);

              return (
                <div key={mealType} className="meal-planner-meal-slot">
                  <span>{mealType}</span>
                  {meal ? (
                    <div>
                      <strong>{meal.recipe.name}</strong>
                      <small>
                        {meal.servings} servings
                        {meal.leftoverSourceId ? ' · leftover' : ''}
                      </small>
                    </div>
                  ) : (
                    <em>Open</em>
                  )}
                </div>
              );
            })}
          </article>
        ))}
      </div>
    </section>
  );
}

export default WeeklyDashboard;
